import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { MojoAvatarModule } from 'mojo-avatar';

import { CandidateCommonModule } from '@shared/candidate-common/candidate-common.module';
import { CandidateResumeModule } from '@shared/candidate-resume/candidate-resume.module';
import { ResumeLinkModule } from '@shared/resume-link/resume-link.module';

import { SimpleCandidateComponent } from './simple-candidate.component';

@NgModule({
  declarations: [SimpleCandidateComponent],
  imports: [
    CommonModule,
    CandidateCommonModule,
    MojoAvatarModule,
    CandidateResumeModule,
    RouterModule,
    ResumeLinkModule,
    MatIconModule,
  ],
  exports: [SimpleCandidateComponent],
})
export class SimpleCandidateModule { }
